// css =>
import "../../BaseStructure.css";
import Styled from "./Favorites.module.css";

// react =>
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Componenets =>
import Header from "../../Components/header/header.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import LocationShow from "../../Components/locationShow/locationShow.comp";
import FirstMenuBar from "../../Components/firstMenuBar/firstMenuBar.comp";
import Product_Displayer from "../../Components/showProduct/showProduct.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";

// pic =>
import NotImage from "../../Assets/Pictures/No_Image.png";

// API =>
import backEnd from "../../services/Api";

// type =>
import { WISH_LIST_RESPONSE } from "./FavoritesType";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";
import MenuBar from "../../Components/menuBar/menuBar.comp";

// hooks =>
import { useUserStore } from "../../hooks/useUserStore";

function Favorites() {

    const navigate = useNavigate();
    const { showMessage } = useMessage();

    const [wishList, setWishList] = useState<WISH_LIST_RESPONSE>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        document.title = "ویدوک | علاقه مندی ها";
        
        setIsLoading(true);
        backEnd.get("products/wishlist/").then(( result ) => {
            setWishList(result.data);
            setIsLoading(false);
        }).catch(( error ) => {
            const status = error.response.status;
            let message = "خطای غیرمنتظره‌ای رخ داد!";
            
                        
            if (error.response) {
                switch (status) {
                    case 400:
                        message = "درخواست شما معتبر نیست.";
                    break;
            
                    case 401:
                    case 403:
                        useUserStore.getState().setUser(null);
                        localStorage.removeItem("user-storage");
            
                        alert("لطفاً ابتدا وارد حساب کاربری خود شوید یا ثبت نام کنید!");
                        navigate("/sign-in");
                    break;
            
                    case 404:
                        message = "پروفایل مورد نظر یافت نشد.";
                    break;
            
                    case 500:
                        message = "خطای سرور، لطفاً بعداً امتحان کنید.";
                    break;
            
                    default:
                        message = error.response.data?.detail || message;
                }
            } else if (error.request) {
                message = "ارتباط با سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                message = "در ارسال درخواست مشکلی به وجود آمد.";
            }

            setIsLoading(false);
            showMessage("error", error.message);        
        });
    }, []);

    return (
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated />
            <LocationShow key={ 0 } pathName="حساب کاربری من" />
            <FirstMenuBar />
            <MenuBar />

            <br />

            <div className="row">
                {
                    isLoading ? (
                        <div className="row">
                            <div className="col-12 SpinnerBarFrame">
                                <SpinnerBar />
                            </div>
                        </div>
                    ) : wishList.length == 0 ? (
                        <p className="EmptyText">هیچ محصولی وجود ندارد!</p>
                    ) : (
                        wishList.map(( item ) => {
                            return <Product_Displayer
                                key={ item.id }
                                productId={ item.product.id }
                                productName={ item.product.full_name }
                                productThumbnail={ item.product.thumbnail || NotImage }
                                productColorList={ item.product.color }
                                productPrice={ item.product.price }
                            />
                        })
                    )
                }
            </div>

        </>
    );
}

export default Favorites;
